
import { openDialog } from '../base/dialog';

import {
    ADD_DONORBOX_URL,
    RECEIVE_DONORBOX_URL,
    REMOVE_DONORBOX_URL,
    REMOVE_MOBILE_DONORBOX_URL } from './actionTypes';
import { getDonorboxModal } from './functions';


/**
* Toggles donorbox dialog.
*
* @returns {Promise}
*/
export function toggleDonorbox() {
    return function(dispatch: (Object) => Object, getState: () => any) {
        const state = getState();

        if (state['features/chat'].addUrl !== null) {
            getDonorboxModal();
        }
    };
}

/**
 * Adds url to Donation Box.
 *
 * @param {string} addUrl - Url for inflicting the modal .
 * @returns {Function}
 */
export function addDonorurl(addUrl: string) {

    return {
        type: ADD_DONORBOX_URL,
        addUrl
    };
}

/**
 * Adds url to Donation Box.
 *
 * @param {string} getUrl - Url for inflicting the modal .
 * @returns {Function}
 */
export function receiveDonorboxURl(getUrl: string) {
    return {
        type: RECEIVE_DONORBOX_URL,
        getUrl
    };
}

/**
 * Removes url from the  Donation Box.
 *
 * @param {string} url - Url for inflicting the modal .
 * @returns {Function}
 */
export function removeDonorboxURl() {
    return {
        type: REMOVE_DONORBOX_URL
    };
}

/**
 * Displays the prompt for entering the Donorbox link.
 *
 * @param {Function} onPostSubmit - The function to be invoked when a valid link is entered.
 * @returns {Function}
 */
export function showEnterDonorLinkPrompt(onPostSubmit: ?Function) {
    const { enterDonorLinkPrompt } = require('./components');

    return openDialog(enterDonorLinkPrompt, { onPostSubmit });
}


/**
 * Removes url from the  Donation Box.
 *
 * @param {string} url - Action for removing the donorbox button.
 * @returns {Function}
 */
export function removeMobileDonorboxURl() {
    return {
        type: REMOVE_MOBILE_DONORBOX_URL
    };
}
